import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button, Input, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Filter, DefaultColumnFilter } from "./filters";
import JobListGlobalFilter from "../../components/Common/GlobalSearchFilter";
import ConfirmModal from "../Modal/ConfirmeModal";
import evaluation from '../../assets/icons/evaluation.png'
import { ExportDataMembers, UpdateMemberRole } from "../../services/MembersServices/Api";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import moment from "moment/moment";
import { colors } from "../../helpers/colors";
import config from "../../config";
import { UpdateRoleUser } from "../../services/AuthServices/Api";
// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = useState(globalFilter);

  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <React.Fragment>
      <Col md={4}>
        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${count} records...`}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && (
        <JobListGlobalFilter />
      )}
    </React.Fragment>
  );
};

const TableContainer = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  className,
  customPageSizeOptions,
  handleClickRow,
  handleClickEnable,
  handleClickRemove,
  handleClickDisable,
  userData,
  dropdownData,
  ShowPaggination

}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );
  const Roles = [
    {
      id : 1,
      label : 'Superviseur'
    },
    {
      id : 2,
      label : 'Intégrateur ;'
    },
    

  ]
  toastr.options = {
    positionClass: "toast-bottom-right",
  }
  const [dropdownValues, setDropdownValues] = useState(dropdownData);
  const [showmodal,setshowmodal] = useState(false)
  const [memberID, setmemberId] = useState()
  const [Role, setRole] = useState()
  const [UserUpdated,setUserUpdated] = useState()
  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const Data = JSON.parse(localStorage.getItem("authUser"));


  const handleDropdownChange = async (item, rowId, selectedValue) => {
    console.log(item)
    setmemberId(rowId)
    setRole(selectedValue)
    item.role = selectedValue
    setUserUpdated(item)
    setshowmodal(true)
    // changeRoleUSer(rowId, selectedValue)
  };

  const changeRoleUSer  = async () =>{
    await UpdateRoleUser(UserUpdated).then((res) =>{
      setshowmodal(false)
      toastr.success("Role d'utilisateur : " + UserUpdated.nom + " était changé avec succès" )

    })
  }

  const handleExportData = async () => {
    const Data = JSON.parse(localStorage.getItem("authUser"));
    const filename = "Exportation-Data-Members-" + moment(new Date()).format('DD-MM-YYYY-hh-mm') + ".xlsx";
  
    try {
      const response = await ExportDataMembers(Data.id, filename, Data.token);
  
      const blobData = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blobData);
  
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
  
      link.click();
  
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error:', error.message);
      // Handle the error as needed
    }
  };
 

  const getRolelabel = (id) =>{

    const rolelabel = Roles.find((item) => item.id === id)
    return rolelabel['label']

  }

  // useEffect(() =>{
  //   data.map(item =>{
  //     console.log(item)
  //       const label =  getRolelabel(item.Role)
  //       setDropdownValues((prevValues) => ({
  //         ...prevValues,
  //         [item.id]: label,
  //       }));
  //   })
  //   console.log(dropdownValues)
  // },[])

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};
const getPlainText = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html; 
  return tempDiv.innerText; 
};

  return (
    <Fragment>
      <Row className="mb-2">
        {/* <Col md={customPageSizeOptions ? 2 : 1}>
          <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
          >   
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col> */}
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          />
        )}
        {isAddOptions && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={handleOrderClicks}
              >
                <i className="mdi mdi-plus me-1" />
                  Add New Order
              </Button>
            </div>
          </Col>
        )}
        {isAddUserList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="primary"
                className="btn mb-2 me-2"
                onClick={handleUserClick}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                  Create New User
              </Button>
            </div>
          </Col>
        )}
        {isAddCustList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClick}
              >
                <i className="mdi mdi-plus me-1" />
                  New Customers
              </Button>
            </div>
          </Col>
        )}
      </Row>

      <div className="table-responsive react-table" style={{paddingBottom : 250}}>
        <div style={{ float : 'right',margin : 10,}}>
          {/* <Button color="primary" onClick={handleExportData} style={{display : 'flex', alignItems : 'center', justifyContent : 'center'}}>
            <span> Exporter les donnes </span>

            <i className=" ri-file-excel-2-fill" style={{marginLeft : 5}}></i>
          </Button> */}
        </div>
        <Table bordered hover {...getTableProps()} className={className} style={{paddingBottom : 10}}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}  >
                {headerGroup.headers.map(column => (
                  <th key={column.id}>
                    <div className="mb-2" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()} style={{ cursor: 'pointer' }}>
            {page.map(row => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr >
                    {row.cells.map(cell => {

                      console.log(row.original.evaluated)

                    

                      if(cell.column.Header == 'Action' && (Data?.role == 2 || Data?.role == 3 )) {  
                        if(cell.row.original['disable'] == 0) {
                        return(
                          <td key={cell.id} {...cell.getCellProps()} style={{display : 'flex', flexDirection : 'row', height : 80, alignItems : 'center', justifyContent : 'center' }}>
                            <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center', marginRight : 20}} onClick={()=>{handleClickDisable(row.original)}} >
                            <i class="fas fa-ban" style={{fontSize : 18, color : colors.red}} ></i>
                            </div>
                            <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center', marginRight : 20}} onClick={()=>{handleClickRemove(row.original)}}>
                            <i class="far fa-trash-alt" style={{fontSize : 18, color : colors.red}} ></i>
                            </div>
                          </td>
                        )
                        } else {
                          return(
                            <td key={cell.id} {...cell.getCellProps()}  style={{display : 'flex', flexDirection : 'row', height : 80, alignItems : 'center', justifyContent : 'center' }}>
                              <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center', marginRight : 20}} onClick={()=>{handleClickEnable(row.original)}}>
                              <i class="far fa-check-circle" style={{fontSize : 18, color : "#2E7D04"}} ></i>
                              </div>
                              <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center', marginRight : 20}} onClick={()=>{handleClickRemove(row.original)}}>
                              <i class="far fa-trash-alt"  style={{fontSize : 18, color : colors.red}} ></i>
                              </div>
                            </td>
                          )
                        }

                      }

                      if(cell.column.Header == 'Icon') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                            <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center'}}>
                              <img
                                src={config.path +  cell.row.original['icon']}
                                style={{height : 50 , borderRadius: 150, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", padding : 5 }}
                              />
                            </div>
                          </td>
                        )

                      }
                      if(cell.column.Header == 'Image Page') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                            <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center'}}>
                              <img
                                src={config.path +  cell.row.original['img']}
                                style={{height : 50 , borderRadius: 10, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"}}
                              />
                            </div>
                          </td>
                        )

                      }

                      if(cell.column.Header == 'Image') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                            <div style={{ display : 'flex',alignItems : 'center', justifyContent : 'center'}}>
                              {cell.row.original['typeFile'] === "Image" ? 
                               <img
                                src={config.path +  cell.row.original['img']}
                                style={{ height: 50, borderRadius: 10, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"}}
                                />
                            :  cell.row.original['typeFile'] === "Audio"  ?
                            <i class="fas fa-file-audio" style={{fontSize : 30}}></i>
                            :  cell.row.original['typeFile'] === "Video"  ?
                            <i class="fas fa-video" style={{fontSize : 30}}></i>
                            :
                            <img
                                src={config.path +  cell.row.original['img']}
                                style={{ height: 50, borderRadius: 10, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"}}
                                />
                            }
                             
                            </div>
                          </td>
                        )

                      }

                      if(cell.column.Header == 'Zone') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                              {cell.row.original.zone['title_fr']}
                          </td>
                        )

                      }

                     

                      if(cell.column.Header == 'Type') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                              {cell.row.original.pageReservation['title_fr']}
                          </td>
                        )

                      }

                      if(cell.column.Header == 'Description') {  
                       
                        return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                              {truncateText(getPlainText(cell.row.original['description_fr']), 30)}
                          </td>
                        )

                      }

                      if(cell.column.Header == 'Status') {  
                       
                          if(cell.row.original['disable'] == 0) { 
                          return(
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                            Activer
                          </td>
                          )
                          
                          } else {
                          return (
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                          <span>Désactivé</span> 
                          </td>
                          )
                         
                        }

                        }

                      if(cell.column.Header == "Date d'ajoute") {
                        return (
                          <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                            {/* {cell.render("Cell")}  */}
                            {moment(cell.render("Cell")).format('DD-MM-YYYY')}
                          </td>
                        );

                      }
                      if(cell.column.Header != 'Accès') {
                      return (
                        <td key={cell.id} {...cell.getCellProps()} onClick={()=>{handleClickRow(row.original)}}>
                          {cell.render("Cell")}
                        </td>
                      );
                      } else if(cell.row.original.isadmin == true &&  cell.row.original.role != 3){
                        return(
                        <UncontrolledDropdown>
                            <DropdownToggle color="primary" type="button">
                            {/* {dropdownValues[cell.row.original.role] || dropdownData[cell.row.original.role] }{" "} */}
                             
                             {cell.row.original.role == 1 ? "Superviseur" : "Intégrateur "} <i className="mdi mdi-chevron-down"></i>
                            </DropdownToggle>
                            <DropdownMenu onChange={(value) => {alert(value)}} style={{ zIndex: 1000 }}>
                              <DropdownItem  onClick={(e) =>{handleDropdownChange(cell.row.original, cell.row.original.userId,1)}}>Superviseur</DropdownItem>
                              <DropdownItem  onClick={(e) =>{handleDropdownChange(cell.row.original,cell.row.original.userId,2)}}>Intégrateur </DropdownItem>
                              
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        )
                      } else if(cell.row.original.role == 3){
                        return(
                        <td key={cell.id} {...cell.getCellProps()}>
                            Admin
                        </td>
                        )

                      } else {
                  
                        return (
                        <td key={cell.id} {...cell.getCellProps()}>
                           Non membre !
                        </td>
                        )
                      }
                    })}
                      {/* <td key={5} >
                          test
                        </td> */}
                  </tr>
                </Fragment>
                
              );
            })}
          </tbody>
              <ConfirmModal
                    show={showmodal}
                    title={"Confirmation de Changement de Rôle"}
                    message={"Êtes-vous sûr(e) de vouloir changer le rôle de cet membre ?"}
                    onDeleteClick={changeRoleUSer}
                    onCloseClick={() => setshowmodal(false)}
                />
        </Table>
      </div>
      {ShowPaggination == true && 
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={pageOptions.length}
            defaultValue={pageIndex + 1}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary" onClick={nextPage} disabled={!canNextPage}>
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
      }
    </Fragment>
  );
};

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
